import CTASubnav from './cta_subnav';

/**
 * Example implementation of the CTASubnav compound component
 * This demonstrates how to use the component with all its sub-components
 * Will be removed when the component is fully implemented
 */
const ExampleImplementation = () => {
  return (
    <CTASubnav>
      <CTASubnav.Title>Product Name</CTASubnav.Title>
      <CTASubnav.Navigation>
        <CTASubnav.Link href="/overview">Overview</CTASubnav.Link>
        <CTASubnav.Link href="/features">Features</CTASubnav.Link>
        <CTASubnav.Link href="/specs">Specifications</CTASubnav.Link>
        <CTASubnav.Link href="/reviews">Reviews</CTASubnav.Link>
      </CTASubnav.Navigation>
      <CTASubnav.Actions>
        <CTASubnav.Secondary>Contact Sales</CTASubnav.Secondary>
        <CTASubnav.Primary>Add to Cart</CTASubnav.Primary>
      </CTASubnav.Actions>
    </CTASubnav>
  );
};

export default ExampleImplementation;
